import { render } from "./ClassItem.vue?vue&type=template&id=2b1fcd66&scoped=true"
import script from "./ClassItem.vue?vue&type=script&lang=ts"
export * from "./ClassItem.vue?vue&type=script&lang=ts"

import "./ClassItem.vue?vue&type=style&index=0&id=2b1fcd66&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2b1fcd66"

export default script